import { mediaUrl } from "@/lib/api";

function youtubeId(url) {
  const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
  return m ? m[1] : null;
}
function vimeoId(url) {
  const m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  return m ? m[1] : null;
}

export default function MediaEmbed({ kind, url, path, poster, className = "", vertical = false }) {
  const aspect = vertical ? "aspect-[9/16]" : "aspect-video";

  if (kind === "upload" && path) {
    const src = mediaUrl(path);
    return (
      <div className={`${aspect} w-full bg-black overflow-hidden ${className}`}>
        <video src={src} poster={poster} controls playsInline className="w-full h-full object-contain bg-black" data-testid="video-player" />
      </div>
    );
  }

  if (kind === "youtube" && url) {
    const id = youtubeId(url);
    if (id) return (
      <div className={`${aspect} w-full ${className}`}>
        <iframe className="w-full h-full" src={`https://www.youtube.com/embed/${id}`} title="video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
      </div>
    );
  }

  if (kind === "vimeo" && url) {
    const id = vimeoId(url);
    if (id) return (
      <div className={`${aspect} w-full ${className}`}>
        <iframe className="w-full h-full" src={`https://player.vimeo.com/video/${id}`} title="video"
          allow="autoplay; fullscreen; picture-in-picture" allowFullScreen />
      </div>
    );
  }

  if (kind === "spotify" && url) {
    const embed = url.replace("open.spotify.com/", "open.spotify.com/embed/");
    return <iframe className={`w-full rounded-xl ${className}`} style={{ height: 152 }} src={embed} title="spotify" allow="encrypted-media" />;
  }

  if (kind === "soundcloud" && url) {
    return <iframe className={`w-full ${className}`} style={{ height: 166 }} scrolling="no" frameBorder="no"
      src={`https://w.soundcloud.com/player/?url=${encodeURIComponent(url)}&color=%23C5A059`} title="soundcloud" />;
  }

  return null;
}
